<template>
  <div v-if="visibleItems.length >= 2" class="page-navigation-bar">
    <div class="page-navigation-bar__content">
      <a
        v-for="item in visibleItems"
        :key="item.id"
        :class="[
          'page-navigation-bar__item',
          { 'page-navigation-bar__item--active': activeSection === item.id }
        ]"
        @click="scrollToSection(item.id)"
      >
        {{ item.label }}
      </a>
    </div>
  </div>
</template>

<script>
import {
  pageNavigationIds,
  pageNavigationItems
} from '../../../constants/pageNavigationConstants'

export default {
  name: 'PageNavigationBar',
  data() {
    return {
      activeSection: pageNavigationIds.GIFT_INFO,
      existingIds: [],
      navigationItems: pageNavigationItems
    }
  },
  computed: {
    visibleItems() {
      return this.navigationItems.filter(item =>
        this.existingIds.includes(item.id)
      )
    }
  },
  mounted() {
    this.checkExistingElements()
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    checkExistingElements() {
      this.existingIds = this.navigationItems
        .filter(item => document.getElementById(item.id) !== null)
        .map(item => item.id)
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        const navBarHeight = this.getNavBarHeight()
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY
        const offsetPosition = elementPosition - navBarHeight

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    },
    getNavBarHeight() {
      const navBar = document.querySelector('.page-navigation-bar')
      const header = document.querySelector('.header')
      const navBarHeight = navBar ? navBar.offsetHeight : 0
      const headerHeight = header ? header.offsetHeight : 0
      return navBarHeight + headerHeight
    },
    handleScroll() {
      const navBarHeight = this.getNavBarHeight()
      const scrollPosition = window.scrollY + navBarHeight + 10

      const visibleIds = this.visibleItems.map(item => item.id)
      const reversedIds = [...visibleIds].reverse()

      const activeId = reversedIds.find(sectionId => {
        const element = document.getElementById(sectionId)
        if (element) {
          const elementTop =
            element.getBoundingClientRect().top + window.scrollY
          return scrollPosition >= elementTop
        }
        return false
      })

      if (activeId) {
        this.activeSection = activeId
      } else if (visibleIds.length > 0) {
        this.activeSection = visibleIds[0]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-navigation-bar {
  position: sticky;
  // PC: ヘッダーの高さ95px、SP: ヘッダーの高さ113px
  top: 95px;
  z-index: 1;
  background-color: $white;
  border-bottom: 1px solid $gray-2;

  @media screen and (max-width: ($base-contents-width - 1)) {
    top: 113px;
  }

  &__content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    max-width: $base-contents-width;
    margin: 0 auto;
    padding: 16px 0;

    @media all and (max-width: ($base-contents-width - 1)) {
      padding: 8px 16px;
    }
  }

  &__item {
    @extend %caption-bold;
    color: $gray-1;
    cursor: pointer;
    text-decoration: none;
    transition: opacity 0.2s ease;
    white-space: nowrap;

    &:hover {
      opacity: 0.7;
    }

    &--active {
      color: $primary;
    }
  }
}
</style>
